import {useSelector} from 'react-redux';

// Component
import MultiRoomHeading from '../../Shared/MultiRoomHeading/MultiRoomHeading';

// Selectors
import {multiRoomFlowStatusSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

export default function ComboHeading() {
  const multiRoomFlowStatus = useSelector(multiRoomFlowStatusSelector);
  const text = multiRoomFlowStatus?.isOnlyOccupancyRooms ? 'Make your combo' : 'Or make your combo';

  return <MultiRoomHeading headingText={text} />;
}
